export const SMART_CAMPAIGN_EMPTY_STATE_CONTENT = [
  {
    id: 1,
    name: 'Holiday Season Campaign',
    description:
      'AI-powered engagement for holiday posts across all social channels.',
    publicContent:
      "positive_sentiment: Thank you for the holiday love! 🎄\nnegative_sentiment: We're sorry to hear that, let us make it right!\nneutral_sentiment: Thanks for joining our holiday celebration!",
    privateContent:
      "greeting: Happy holidays! 🎁\nmessage: Here's an exclusive 50% off just for you — use code HOLIDAY50 at checkout.\nclosing: Wishing you a wonderful season. Feel free to reply anytime!",
    referenceContent:
      'Annual holiday sale runs Dec 20 – Jan 2. Discounts 30–50% sitewide. Free shipping over $50. Emphasise warmth and generosity in all replies.',
    hashtags: ['holidaysale', 'christmas', 'deals'],
    inboxes: [
      { id: 1, name: 'Instagram Store' },
      { id: 2, name: 'Facebook Page' },
    ],
    startsAt: '2025-12-20T00:00:00Z',
    endsAt: '2026-01-02T23:59:00Z',
  },
  {
    id: 2,
    name: 'Spring Collection 2026',
    description:
      'Promote the spring collection with automated AI engagement on social posts.',
    publicContent:
      "positive_sentiment: So glad you love the spring collection! 🌸\nnegative_sentiment: Sorry for the inconvenience — we'd love to help!\nneutral_sentiment: Thanks for checking out our spring styles!",
    privateContent:
      "greeting: Hi there! 👋\nmessage: Thanks for engaging with our spring post! Here's an early-bird 15% off — use SPRING15 at checkout.\nclosing: Happy spring shopping! Reply anytime if you need help.",
    referenceContent:
      'Spring 2026 Collection: 12 new styles in sustainable fabrics. Available from April 1, online and in-store. Price range $35–$120. Emphasise freshness and sustainability.',
    hashtags: ['spring2026', 'newcollection', 'fashion'],
    inboxes: [{ id: 3, name: 'Brand Instagram' }],
    startsAt: '2026-04-01T00:00:00Z',
    endsAt: '2026-04-30T23:59:00Z',
  },
  {
    id: 3,
    name: 'Summer Sale Kickoff',
    description:
      'Drive summer engagement with AI replies on promotional posts and comments.',
    publicContent:
      "positive_sentiment: Summer vibes incoming! ☀️ So glad you're excited!\nnegative_sentiment: We hear you — our summer sale will make it worth the wait.\nneutral_sentiment: Summer savings are just around the corner!",
    privateContent:
      'greeting: Hey! ☀️\nmessage: Big summer deals are coming your way. Reply EARLY for exclusive early access before the public launch!\nclosing: Stay tuned — this will be our best sale yet!',
    referenceContent:
      'Summer sale launches May 15. Up to 60% off selected categories. Emphasise excitement and exclusivity. Early access available to engaged followers.',
    hashtags: ['summersale', 'comingsoon', 'deals'],
    inboxes: [
      { id: 1, name: 'Instagram Store' },
      { id: 4, name: 'Facebook Business' },
    ],
    startsAt: '2026-05-15T00:00:00Z',
    endsAt: '2026-06-15T23:59:00Z',
  },
];
